import React, { useEffect, useState } from "react"
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import AccidentHistoryTable from "./AccidentHistoryTable";

const AccidentsHistory = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const [currentTab, setCurrentTab] = useState('create');
    const [isEditMode, setIsEditMode] = useState(false);
    let edit = state?.edit;
    let data = state?.data;

    useEffect(() => {
        GridStack.init();

        // Set edit mode if edit state is present
        if (edit && data) {
            setIsEditMode(true);
            setCurrentTab('assign');
        }
    }, [edit, data]);

    

   

    

    return (
        <div className="smartpole__header--transition" style={{ minHeight: '100vh', background: '#F0F6FB' }}>
            <AccidentHistoryTable edit={edit} isEditMode={isEditMode} refreshAt={state?.refreshAt} />
        </div>
    );
}

export default AccidentsHistory;